import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodOptionalId, zodPage, zodSort } from 'routes/routeUtils';
import { z } from 'zod';

export const adminClaimsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/invoices',
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
    sort: zodSort(['pharmacy_name', 'lab_name', 'created_at', 'status', 'topic_title']),
    tab: z
      .enum([
        'not_seen',
        'to_be_treated',
        'snoozed',
        'in_relaunch',
        'with_lab_but_without_relaunch',
        'pending',
        'closed_by_lab',
        'archived_by_pharmacy',
        'deleted',
        'by_email',
        'all',
      ])
      .default('not_seen'),
    pharmacyId: zodOptionalId,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/admin/Claims/AdminClaimsPage/AdminClaimsPage').then((d) => d.Route));
